import store from '~/store'

export default async (to, from, next) => {
  // if user not present try to get user
  if (!store.getters["auth/user"]) {
    await store.dispatch("auth/fetchUser");

    if (!store.getters["auth/user"]) {
      return;
    }
  }

  if (store.getters['auth/user'].role !== 'admin') {
    next({ name: 'dashboard' })
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./resources/js/router/middleware/admin.js